<!--
  SentenceList · 右侧句子面板（展示 + 点击跳转 + 选词翻译）
  props: sentences / currentIdx
  emit:  select(idx)           父组件处理 seek
         select-text({text,x,y})  选词翻译
  高亮：只用 Vue reactive currentIdx prop 驱动 :class="{active}"，不要外部直接改 DOM class
-->
<template>
  <aside class="sen-panel">
    <div class="sen-head">
      <b>句子列表</b>
      <span class="chip">共 {{ sentences.length }} 句</span>
    </div>
    <div class="sen-list" ref="listEl">
      <div v-if="!sentences.length" style="padding:24px;color:var(--mute)">
        请先在上方选择课程，或上传新视频…
      </div>
      <div
        v-for="(s, i) in sentences"
        :key="i"
        class="sen-item"
        :class="{active: i === currentIdx}"
        :data-i="i"
        @click="onItemClick(i)"
        @mouseup="onMouseUp"
      >
        <div class="t">#{{ i + 1 }} · {{ fmt(s.start) }} → {{ fmt(s.end) }}</div>
        <div class="en">{{ s.en || '(empty)' }}</div>
        <div v-if="s.zh" class="zh">{{ s.zh }}</div>
      </div>
    </div>
  </aside>
</template>

<script setup>
import { nextTick, ref, watch } from 'vue'
import { fmtTime } from '@/composables/usePlayerState'

const props = defineProps({
  sentences: { type: Array, default: () => [] },
  currentIdx: { type: Number, default: -1 },
})
const emit = defineEmits(['select', 'select-text'])

const listEl = ref(null)

function fmt(t) { return fmtTime(t) }

/** 点击句子：如果有选中文本则不跳转（让浏览器处理选择） */
function onItemClick(i) {
  const sel = window.getSelection().toString().trim()
  if (sel) return
  emit('select', i)
}

/** 鼠标抬起：检测选中文本，触发翻译弹窗 */
function onMouseUp(e) {
  const sel = window.getSelection().toString().trim()
  if (sel) emit('select-text', { text: sel, x: e.clientX, y: e.clientY })
}

/** 滚动到第 i 句居中（class="active" 由 Vue prop 自动驱动，不用手动加 class） */
async function scrollToActive(i) {
  await nextTick()
  const cur = listEl.value?.querySelector?.(`.sen-item[data-i="${i}"]`)
    || document.querySelector(`.sen-item[data-i="${i}"]`)
  if (cur) cur.scrollIntoView({ block: 'center', behavior: 'smooth' })
}

// currentIdx 变化时自动滚动（父组件也可以显式调用 markActive 手动触发）
watch(() => props.currentIdx, (v) => { if (v >= 0) scrollToActive(v) }, { flush: 'post' })

defineExpose({
  markActive(i) { scrollToActive(i) },
})
</script>
